import { URI_TARIFF_PLAN } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const userLoginInfoResult = await fetch(
    `${URI_TARIFF_PLAN}reversion/create-reversal`,
    opts,
  );
  const jsonResult = await userLoginInfoResult.json();
  if (jsonResult.error) {
    return Promise.reject(jsonResult.error);
  }

  return jsonResult.credits;
};
